// extracted by mini-css-extract-plugin
export default {"info":"About_info__Byfnu","descr":"About_descr__X-048","skills":"About_skills__SzKaK","btn":"About_btn__MubUc","extLink":"About_extLink__4O1aG"};